import { createAction } from '@reduxjs/toolkit';
import type { Theme } from '@soteria/design-system-ve';

/**
 * Set the theme (light, dark, or system)
 */
export const setTheme = createAction<'light' | 'dark' | 'system'>('theme/setTheme');

/**
 * Set the complete theme object from the design system
 */
export const setCompleteTheme = createAction<Theme>('theme/setCompleteTheme');

/**
 * Set whether high contrast mode is enabled
 */
export const setHighContrast = createAction<boolean>('theme/setHighContrast');

/**
 * Toggle between light and dark themes
 */
export const toggleTheme = createAction('theme/toggleTheme');
